export default __webpack_public_path__ + "static/media/tableau-logo.33e20a8f.svg";